package de.ohhhmhhh.frontend.admin.ui.screens.text.edit

import com.benasher44.uuid.uuid4
import de.ohhhmhhh.backend.models.model.text.InsertStaticTextRevisionRequest
import de.ohhhmhhh.backend.models.model.text.StaticTextEntity
import de.ohhhmhhh.backend.sdk.text.TextService
import de.ohhhmhhh.frontend.admin.helper.Formats
import de.ohhhmhhh.frontend.admin.mvvm.BaseViewModel
import de.ohhhmhhh.frontend.admin.ui.components.inputs.SelectItem
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.offsetAt

class TextEditViewModel(
    private val service: TextService
) : BaseViewModel<TextEditState>(TextEditState()) {

    private companion object {
        const val KEY_CURRENT = Int.MAX_VALUE.toString()
    }

    private val revisions = mutableMapOf<String, StaticTextEntity>()

    fun setTitle(title: String) = update { copy(title = title) }

    fun setContent(content: String) = update { copy(content = content) }

    fun save() {
        val state = value()
        val id = state.id ?: return
        val request = InsertStaticTextRevisionRequest(
            id = id,
            title = state.title ?: "",
            content = state.content ?: "",
        )

        launch {
            service.addRevision(request)
            update { copy(saved = uuid4().toString()) }
            load(id)
        }
    }

    fun setRevision(key: String, persist: Boolean = true) {
        if (persist) saveStateToRevision()

        revisions[key]?.also {
            update {
                copy(
                    id = it.id,
                    title = it.title,
                    content = it.content,
                    version = if (key == KEY_CURRENT) null else it.version.toString(),
                    revision = key,
                    savable = key == KEY_CURRENT,
                    type = it.type
                )
            }
        }
    }

    fun load(id: String) {
        launch {
            val set = service.getRevisions(id)
            val newest = set.maxBy { it.version }
            val revisions = set.groupBy { it.version.toString() }.mapValues { it.value.first() } +
                    mapOf(KEY_CURRENT to newest)
            this.revisions.clear()
            this.revisions.putAll(revisions)

            val entries = set.sortedBy { it.version }.map { entity ->
                val offset = TimeZone.currentSystemDefault().offsetAt(entity.created)
                val date = entity.created.format(Formats.Instant.dateTime, offset)
                val key = entity.version.toString()
                val label = "V$key - $date"
                SelectItem(key, label)
            } + SelectItem(KEY_CURRENT, "Aktuell")
            update { copy(revisions = entries) }

            setRevision(KEY_CURRENT, false)
        }
    }

    private fun saveStateToRevision() {
        val state = value()
        val currentKey = state.revision ?: return
        val currentRevision = revisions[currentKey] ?: return
        val updatedRevision = currentRevision.copy(
            title = state.title ?: "",
            content = state.content ?: "",
        )
        revisions[currentKey] = updatedRevision
    }
}